/* Abby Home: app-style behaviour for the website.
   - Favorites: heart button on every product card, saved in this browser.
   - Recently viewed: products you opened, shown on the home page.
   - Favorites page: /collections/all?view=favorites
   - Mobile tab bar: live counts for favorites and cart; Cart opens the drawer.
   - Hero slides: auto-advance with dots. */
(function () {
  'use strict';

  var FAV_KEY = 'ah_favs';
  var RV_KEY = 'ah_recent';
  var RV_MAX = 12;

  function read(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(key, list) {
    try {
      localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {}
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function handleFromHref(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = window.ahMoneyFormat || '{{amount}}';
    var value = cents / 100;
    function withDelims(n, decimals, thousands, dec) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Icons ---------- */
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.1C1.5 8.3 3.3 4.8 6.8 4.6c2-.1 3.6 1 5.2 2.9 1.6-1.9 3.2-3 5.2-2.9 3.5.2 5.3 3.7 4.1 6.8-1.8 4.5-9.3 9.1-9.3 9.1z" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"/></svg>';

  /* ---------- Favorites ---------- */
  function isFav(handle) {
    return read(FAV_KEY).indexOf(handle) !== -1;
  }

  function toggleFav(handle) {
    var list = read(FAV_KEY);
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle);
    else list.splice(i, 1);
    write(FAV_KEY, list);
    syncHearts();
    updateBadges();
    document.dispatchEvent(new CustomEvent('ah:favorites-changed'));
    return i === -1;
  }

  function heartButton(handle, title, extraClass) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ah-heart' + (extraClass ? ' ' + extraClass : '');
    b.setAttribute('data-ah-fav', handle);
    b.setAttribute('aria-pressed', isFav(handle) ? 'true' : 'false');
    b.setAttribute('aria-label', (isFav(handle) ? 'Remove from favorites: ' : 'Save to favorites: ') + (title || handle));
    b.innerHTML = HEART;
    return b;
  }

  function syncHearts() {
    var favs = read(FAV_KEY);
    document.querySelectorAll('[data-ah-fav]').forEach(function (b) {
      var on = favs.indexOf(b.getAttribute('data-ah-fav')) !== -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ah-fav]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var on = toggleFav(b.getAttribute('data-ah-fav'));
    var label = b.getAttribute('aria-label') || '';
    b.setAttribute('aria-label', label.replace(/^(Remove from favorites|Save to favorites): /, on ? 'Remove from favorites: ' : 'Save to favorites: '));
  }, true);

  function decorateCards(scope) {
    (scope || document).querySelectorAll('.product-card-wrapper').forEach(function (card) {
      if (card.querySelector('.ah-heart')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var handle = link && handleFromHref(link.getAttribute('href'));
      if (!handle) return;
      var host = card.querySelector('.card__inner') || card.querySelector('.card');
      if (!host) return;
      var title = (card.querySelector('.card__heading') || {}).textContent;
      host.appendChild(heartButton(handle, title && title.trim()));
    });
  }

  function decorateProductPage() {
    var info = document.querySelector('.product__info-container');
    if (!info || info.querySelector('.ah-heart')) return;
    var handle = handleFromHref(location.pathname);
    var titleEl = info.querySelector('.product__title');
    if (!handle || !titleEl) return;
    var row = document.createElement('div');
    row.className = 'ah-title-row';
    titleEl.parentNode.insertBefore(row, titleEl);
    row.appendChild(titleEl);
    row.appendChild(heartButton(handle, titleEl.textContent.trim(), 'ah-heart--inline'));
  }

  var lastCartCount = null;
  function decorateCartHeading() {
    document.querySelectorAll('cart-drawer .drawer__heading, cart-items .title-wrapper-with-link .title').forEach(function (h) {
      if (h.querySelector('[data-ah-cart-heading-count]')) return;
      var s = document.createElement('span');
      s.className = 'ah-count';
      s.setAttribute('data-ah-cart-heading-count', '');
      s.setAttribute('aria-label', 'items in cart');
      if (lastCartCount !== null) s.textContent = lastCartCount;
      s.hidden = !lastCartCount;
      h.appendChild(s);
    });
  }

  /* ---------- Recently viewed ---------- */
  function recordView() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    var isProduct = (meta && meta.page && meta.page.pageType === 'product') || document.querySelector('product-info');
    if (!isProduct) return;
    var handle = handleFromHref(location.pathname);
    if (!handle) return;
    var list = read(RV_KEY).filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(RV_KEY, list.slice(0, RV_MAX));
  }

  var productCache = {};
  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function img(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function cardHTML(p) {
    var url = root + 'products/' + p.handle;
    var price = p.price_varies ? 'From ' + formatMoney(p.price_min) : formatMoney(p.price);
    var src = p.featured_image;
    return '<article class="ah-card">' +
      '<div class="ah-card__media">' +
        (src ? '<img src="' + esc(img(src, 500)) + '" srcset="' + esc(img(src, 300)) + ' 300w, ' + esc(img(src, 500)) + ' 500w, ' + esc(img(src, 800)) + ' 800w" sizes="(min-width: 750px) 25vw, 45vw" alt="' + esc(p.title) + '" loading="lazy" width="500" height="500">' : '') +
      '</div>' +
      '<div class="ah-card__body">' +
        '<h3 class="ah-card__title"><a href="' + esc(url) + '">' + esc(p.title) + '</a></h3>' +
        '<div class="ah-card__price">' + esc(price) + '</div>' +
      '</div>' +
    '</article>';
  }

  function renderList(container, handles, onEmpty) {
    if (!container) return;
    if (!handles.length) {
      onEmpty && onEmpty();
      return;
    }
    Promise.all(handles.map(fetchProduct)).then(function (products) {
      var live = products.filter(Boolean);
      if (!live.length) {
        onEmpty && onEmpty();
        return;
      }
      container.innerHTML = live.map(cardHTML).join('');
      container.querySelectorAll('.ah-card').forEach(function (card, i) {
        var p = live[i];
        card.querySelector('.ah-card__media').appendChild(heartButton(p.handle, p.title));
      });
    });
  }

  function renderRecentlyViewed() {
    document.querySelectorAll('[data-ah-recent]').forEach(function (section) {
      var list = section.querySelector('[data-ah-recent-list]');
      var handles = read(RV_KEY);
      var current = handleFromHref(location.pathname);
      if (current) handles = handles.filter(function (h) { return h !== current; });
      handles = handles.slice(0, parseInt(section.getAttribute('data-limit') || '8', 10));
      if (!handles.length) {
        section.hidden = true;
        return;
      }
      section.hidden = false;
      renderList(list, handles, function () { section.hidden = true; });
    });
  }

  function renderFavoritesPage() {
    var page = document.querySelector('[data-ah-favorites]');
    if (!page) return;
    var grid = page.querySelector('[data-ah-favorites-grid]');
    var empty = page.querySelector('[data-ah-favorites-empty]');
    var count = page.querySelector('[data-ah-favorites-count]');
    function draw() {
      var handles = read(FAV_KEY);
      if (count) count.textContent = handles.length ? String(handles.length) : '';
      if (!handles.length) {
        grid.innerHTML = '';
        grid.hidden = true;
        empty.hidden = false;
        return;
      }
      grid.hidden = false;
      empty.hidden = true;
      renderList(grid, handles, function () {
        grid.hidden = true;
        empty.hidden = false;
      });
    }
    draw();
    document.addEventListener('ah:favorites-changed', draw);
  }

  /* ---------- Tab bar ---------- */
  function setBadge(el, n) {
    if (!el) return;
    el.textContent = n > 99 ? '99+' : String(n);
    el.hidden = !n;
  }

  function updateBadges(cartCount) {
    var favs = read(FAV_KEY).length;
    document.querySelectorAll('[data-ah-fav-count]').forEach(function (el) { setBadge(el, favs); });
    if (typeof cartCount === 'number') {
      document.querySelectorAll('[data-ah-cart-count]').forEach(function (el) { setBadge(el, cartCount); });
    }
  }

  function refreshCartCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        lastCartCount = c.item_count;
        updateBadges(c.item_count);
        decorateCartHeading();
        document.querySelectorAll('[data-ah-cart-heading-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.hidden = !c.item_count;
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ah-open-cart]');
    if (!t) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      e.preventDefault();
      drawer.open(t);
    }
  });

  /* ---------- Hero slides ---------- */
  function initSlides() {
    document.querySelectorAll('[data-ah-slides]').forEach(function (wrap) {
      if (wrap.dataset.ahReady) return;
      wrap.dataset.ahReady = '1';
      var slides = Array.prototype.slice.call(wrap.querySelectorAll('[data-ah-slide]'));
      var dots = Array.prototype.slice.call(wrap.querySelectorAll('[data-ah-dot]'));
      if (slides.length < 2) return;
      var i = 0;
      var timer;
      var delay = parseInt(wrap.getAttribute('data-delay') || '6', 10) * 1000;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
          s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
        });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      function start() {
        if (reduce) return;
        stop();
        timer = setInterval(function () { show(i + 1); }, delay);
      }
      function stop() { if (timer) clearInterval(timer); }
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () { show(k); start(); });
      });
      var x0 = null;
      wrap.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
        x0 = null;
        start();
      });
      wrap.addEventListener('mouseenter', stop);
      wrap.addEventListener('mouseleave', start);
      show(0);
      start();
    });
  }

  /* ---------- Login: show / hide password ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ah-pw-toggle]');
    if (!t) return;
    var input = t.parentNode.querySelector('input');
    if (!input) return;
    var show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    t.setAttribute('aria-pressed', show ? 'true' : 'false');
    t.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
  });

  /* ---------- Boot ---------- */
  function boot() {
    recordView();
    decorateCards();
    decorateProductPage();
    renderRecentlyViewed();
    renderFavoritesPage();
    initSlides();
    updateBadges();
    refreshCartCount();

    if ('MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          decorateCards();
          decorateProductPage();
          decorateCartHeading();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshCartCount);
    }
    document.addEventListener('cart:refresh', refreshCartCount);
    window.addEventListener('pageshow', function (e) { if (e.persisted) { refreshCartCount(); syncHearts(); updateBadges(); } });
    window.addEventListener('storage', function (e) {
      if (e.key === FAV_KEY) { syncHearts(); updateBadges(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
